import * as t from 'io-ts';

import {makeEnumRuntimeType, RContactUidRef} from './apiTypes';
import {buildContactUid, ContactSourcesEnum} from './contactModel';
import {VisualParticipantModel} from './visualParticipantModel';

/*
 * Runtime type.
 */

export enum ParticipantTypesEnum {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
  RESOURCE = 'resource',
}
export const RParticipantType = makeEnumRuntimeType(ParticipantTypesEnum);

export enum ParticipantResponseStatusesEnum {
  NONE = 'NONE',
  PENDING = 'needs-action',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  TENTATIVE = 'tentative',
  DELEGATED = 'delegated',
}
export const RParticipantResponseStatus = makeEnumRuntimeType(ParticipantResponseStatusesEnum);

const RParticipantDirty = t.readonly(
  t.intersection([
    t.type({
      contactUid: RContactUidRef,
      type: RParticipantType,
      isOrganizer: t.boolean,
      isCreator: t.boolean,
      isAttendee: t.boolean,
      responseStatus: RParticipantResponseStatus,
    }),
    t.partial({
      name: t.string,
    }),
  ]),
);

/*
 * Type.
 */

export interface ParticipantModel extends t.TypeOf<typeof RParticipantDirty> {}
export const RParticipant = t.clean<ParticipantModel>(RParticipantDirty as any);

/*
 * IO methods.
 */

export function parseParticipant(src: any): ParticipantModel {
  return {
    contactUid: buildContactUid(ContactSourcesEnum.EMAIL, src.address.toLowerCase()), // TODO: Move lowercasing logic to backend.
    type: src.type,
    name: src.name || undefined,
    responseStatus: src.response_status || ParticipantResponseStatusesEnum.NONE,
    isOrganizer: src.extra.organizer,
    isCreator: src.extra.creator,
    isAttendee: src.extra.attendee,
  };
}

export function serializeParticipant(visualParticipant: VisualParticipantModel) {
  const responseStatus =
    visualParticipant.responseStatus === ParticipantResponseStatusesEnum.NONE
      ? null
      : visualParticipant.responseStatus;

  return {
    name: visualParticipant.name,
    address: visualParticipant.contact.handle,
    response_status: responseStatus,
    type: visualParticipant.type,
    extra: {
      organizer: visualParticipant.isOrganizer,
      creator: visualParticipant.isCreator,
      attendee: visualParticipant.isAttendee,
    },
  };
}
